import type { Platform } from '@/contexts/PlatformContext';

export const GITHUB_ORG = 'pocket-agent';

export const GITHUB_OWNER = 'charlite';

export const GITHUB_ORG_URL = `https://github.com/${GITHUB_ORG}`;

export const GITHUB_PROFILE_URL = `https://github.com/${GITHUB_OWNER}`;

export const APP_NAME_SHORT = 'PocketAgent™';

/** App Store Connect listing (iOS + macOS on one record). */
export const APP_STORE_URL =
  'https://apps.apple.com/us/app/pocketagent-chatbot/id6816867795';

/** Name on the App Store (App Store Connect). */
export const APP_STORE_LISTING_NAME = 'PocketAgent™';

export const SITE_URL = 'https://pocket-agent.pages.dev';

export const SUPPORT_URL = `${SITE_URL}/contact`;

const PLATFORM_RELEASES: Record<
  Platform,
  {
    appName: string;
    promotionalText: string;
  }
> = {
  ios: {
    appName: 'PocketAgent for iOS',
    promotionalText:
      'PocketAgent on iPhone — pair with your Mac agent node on Wi‑Fi, stream chat with tool activity, save known Macs, and keep your transcript on device.',
  },
  macos: {
    appName: 'PocketAgent for Mac',
    promotionalText:
      'PocketAgent on Mac — run your core agent node: multi-agent chat, Apple on-device AI, Ollama & OpenAI-compatible servers, iPhone pairing, Telegram, and traces.',
  },
};

export function getPlatformReleases(platform: Platform) {
  const entry = PLATFORM_RELEASES[platform];
  return {
    APP_NAME: entry.appName,
    APP_STORE_URL,
    APP_STORE_LISTING_NAME,
    APP_STORE_PROMOTIONAL_TEXT: entry.promotionalText,
    APP_STORE_DESCRIPTION: entry.promotionalText,
  };
}
